/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { LessonRead } from './LessonRead';
import {
    LessonReadFromJSON,
    LessonReadFromJSONTyped,
    LessonReadToJSON,
    LessonReadToJSONTyped,
} from './LessonRead';
import type { TutorialTagRead } from './TutorialTagRead';
import {
    TutorialTagReadFromJSON,
    TutorialTagReadFromJSONTyped,
    TutorialTagReadToJSON,
    TutorialTagReadToJSONTyped,
} from './TutorialTagRead';

/**
 * Schema for tutorial with its lessons.
 * @export
 * @interface TutorialWithLessons
 */
export interface TutorialWithLessons {
    /**
     * 
     * @type {string}
     * @memberof TutorialWithLessons
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof TutorialWithLessons
     */
    description?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TutorialWithLessons
     */
    is_public?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TutorialWithLessons
     */
    deleted?: boolean;
    /**
     * 
     * @type {number}
     * @memberof TutorialWithLessons
     */
    complexity?: number;
    /**
     * 
     * @type {string}
     * @memberof TutorialWithLessons
     */
    language?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TutorialWithLessons
     */
    field?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TutorialWithLessons
     */
    created_by_id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TutorialWithLessons
     */
    id: string;
    /**
     * 
     * @type {Date}
     * @memberof TutorialWithLessons
     */
    created_at: Date;
    /**
     * 
     * @type {string}
     * @memberof TutorialWithLessons
     */
    created_by_name?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof TutorialWithLessons
     */
    organization_ids?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof TutorialWithLessons
     */
    organization_names?: Array<string>;
    /**
     * 
     * @type {Array<TutorialTagRead>}
     * @memberof TutorialWithLessons
     */
    tags?: Array<TutorialTagRead>;
    /**
     * 
     * @type {Array<LessonRead>}
     * @memberof TutorialWithLessons
     */
    lessons?: Array<LessonRead>;
}

/**
 * Check if a given object implements the TutorialWithLessons interface.
 */
export function instanceOfTutorialWithLessons(value: object): value is TutorialWithLessons {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('created_at' in value) || value['created_at'] === undefined) return false;
    return true;
}

export function TutorialWithLessonsFromJSON(json: any): TutorialWithLessons {
    return TutorialWithLessonsFromJSONTyped(json, false);
}

export function TutorialWithLessonsFromJSONTyped(json: any, ignoreDiscriminator: boolean): TutorialWithLessons {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'is_public': json['is_public'] == null ? undefined : json['is_public'],
        'deleted': json['deleted'] == null ? undefined : json['deleted'],
        'complexity': json['complexity'] == null ? undefined : json['complexity'],
        'language': json['language'] == null ? undefined : json['language'],
        'field': json['field'] == null ? undefined : json['field'],
        'created_by_id': json['created_by_id'] == null ? undefined : json['created_by_id'],
        'id': json['id'],
        'created_at': (new Date(json['created_at'])),
        'created_by_name': json['created_by_name'] == null ? undefined : json['created_by_name'],
        'organization_ids': json['organization_ids'] == null ? undefined : json['organization_ids'],
        'organization_names': json['organization_names'] == null ? undefined : json['organization_names'],
        'tags': json['tags'] == null ? undefined : ((json['tags'] as Array<any>).map(TutorialTagReadFromJSON)),
        'lessons': json['lessons'] == null ? undefined : ((json['lessons'] as Array<any>).map(LessonReadFromJSON)),
    };
}

export function TutorialWithLessonsToJSON(json: any): TutorialWithLessons {
    return TutorialWithLessonsToJSONTyped(json, false);
}

export function TutorialWithLessonsToJSONTyped(value?: TutorialWithLessons | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'description': value['description'],
        'is_public': value['is_public'],
        'deleted': value['deleted'],
        'complexity': value['complexity'],
        'language': value['language'],
        'field': value['field'],
        'created_by_id': value['created_by_id'],
        'id': value['id'],
        'created_at': ((value['created_at']).toISOString()),
        'created_by_name': value['created_by_name'],
        'organization_ids': value['organization_ids'],
        'organization_names': value['organization_names'],
        'tags': value['tags'] == null ? undefined : ((value['tags'] as Array<any>).map(TutorialTagReadToJSON)),
        'lessons': value['lessons'] == null ? undefined : ((value['lessons'] as Array<any>).map(LessonReadToJSON)),
    };
}

